import { selectCountries } from 'legacy/lut/selectors/app'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ICountry } from 'core/classes/models/IReference'

export const useCountriesMappedByCode = () => {
  const countries = useSelector(selectCountries)

  return useMemo(() => {
    const mapped = new Map<string, ICountry>()
    countries.forEach((i) => {
      mapped.set(i.value, i)
    })

    return mapped
  }, [countries])
}
